export default __webpack_public_path__ + "static/media/photo11.0da569ed.jpg";